import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = user
  const [business, setBusiness] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("pf_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setBusiness(data.business);
      setSubscription(data.subscription);
      setUnread(data.unread_notifications || 0);
    } catch (e) {
      localStorage.removeItem("pf_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWithToken = async (token, userObj) => {
    localStorage.setItem("pf_token", token);
    setUser(userObj);
    await refresh();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("pf_token");
    setUser(false);
    setBusiness(null);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, business, subscription, unread, setUnread, refresh, loginWithToken, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
